<template>
  <Catalogs
    title="Теги заявок на подбор"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'RecruitTagAdd'"
    :route-edit="'RecruitTagEdit'"
    :route-view="'RecruitTagView'"
    :route-path="'/recruit_tags'"
    :can-edit="canEditRecruitTagCatalogs()"
  >
    <template #name-tag="{ item }">
      <b-badge pill :style="getBadgeStyle(item.color)" class="px-2 py-1">
        {{ item.name }}
      </b-badge>
    </template>
  </Catalogs>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
  import helpers from "../../../utilites/helpers";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "RecruitTags",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions, helpers
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'recruit-tag-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'color',
          tdClass: 'd-none',
          thClass: 'd-none'
        },
        {
          key: 'description',
          label: "Описание",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'recruit-tag-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getRecruitTags(data);
    },
    canEditRecruitTagCatalogs() {
      return this.hasPermission([PERM.CATALOG_RECRUIT_TAG_EDIT]);
    },
  }
}
</script>

<style>
.recruit-tag-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.recruit-tag-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/RecruitTags/RecruitTags.vue